import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "n-icon" }
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_3 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-send-icon',
},
  __name: 'send-icon',
  props: {
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
      }, null, -1)),
      _createElementVNode("path", {
        d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2 .01 7z",
        fill: __props.fill
      }, null, 8, _hoisted_3)
    ]))
  ]))
}
}

})